import { createSlice } from "@reduxjs/toolkit";

import { LIVE_CHAT_COUNT } from "./constants";

const chatSlice = createSlice({
    name: "chat",
    initialState: {
        messages: []
    },
    reducers: {
        addMessage: (state, action) => {
            if (state.messages.length >= LIVE_CHAT_COUNT) {
                state.messages.shift()
            }
            state.messages.push(action.payload);
        },
        clearMessages: (state) => {
            state.messages = [];
        },
    }
})

export const { addMessage, clearMessages } = chatSlice.actions;
export default chatSlice.reducer;